import './ScheduleConsultation.css';

const ScheduleConsultation = () => {
  return (
    <>
      <h1 className="coach-title">Coming soon</h1>
    </>
  );
};

export default ScheduleConsultation;
